// extracted by mini-css-extract-plugin
export var root = "Skill-module--root--1OaAO";
export var rating = "Skill-module--rating--2gq3f";
export var nameLink = "Skill-module--nameLink--3w743";
export var ratings = "Skill-module--ratings--35kZ_";
export var strengthRating = "Skill-module--strengthRating--1nSak";
export var stale = "Skill-module--stale--2rO_0";